export default __webpack_public_path__ + "static/media/FHash1.4016cc44.mp3";